'use client';

import { useRef } from 'react';

import cx from 'classnames';

import CloseIcon from '~/ui/assets/icons/close.svg';
import { type ButtonSize, type ButtonVariant } from '~/ui/components/button';
import { AsyncButton } from '~/ui/components/button/async';

import styles from './pill.module.scss';

export interface PillProps {
  className?: string;
  label: string;
  size: ButtonSize;
  variant: ButtonVariant;
  onClick?: () => void;
  onMouseEnter?: () => void;
}

export function Pill({ className, label, size, variant, onClick }: PillProps): React.ReactElement {
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <li className={cx(className)} onClick={() => buttonRef.current?.click()}>
      <AsyncButton
        size={size}
        variant={variant}
        ref={buttonRef}
        onClick={async () => onClick?.()}
        aria-label="Remove"
      >
        {label}
        <CloseIcon className={styles.icon} />
      </AsyncButton>
    </li>
  );
}
